import { NavLink } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import "./styles.css";

const navLinkClassNames = isActive =>
  classNames(
    {
      "text-circle link-active": isActive,
      "text-default link-inactive": !isActive,
    },
    "relative flex flex-col gap-2 hover:text-circle focus:text-circle w-1/5 text-center",
  );

export const BottomMenu = () => (
  <div className="flex h-[76px] w-full items-center justify-evenly text-xs">
    <NavLink
      to="/"
      className={navLinkClassNames}
      isActive={(match, location) => location.pathname === "/"}
    >
      <Icon type="home-v2" viewBox="0 0 16 16" />
      <span>{t("support_widget.bottom_menu.home")}</span>
    </NavLink>
    <NavLink to="/conversations" className={navLinkClassNames}>
      <Icon type="16-messages" viewBox="0 0 16 16" />
      <span>{t("support_widget.bottom_menu.messages")}</span>
    </NavLink>
  </div>
);
